import type { RepresentativeType } from './types';

export const normalizeRepresentative = (representative: RepresentativeType): RepresentativeType => {
  return {
    firstName: representative.firstName.trim(),
    lastName: representative.lastName.trim(),
    email: representative.email.trim(),
    phone: representative.phone.replace(/\s+/g, ''),
  };
};
